<template>
  <section class="welcome-page clipr-theme twitch-theme">
    <header class="welcome-page-header">
      <span class="welcome-page-eyebrow">{{ tt("welcome.eyebrow", "EMPIEZA AQUÍ") }}</span>
      <h1>{{ tt("welcome.title", "Bienvenido a Clipr") }}</h1>
      <p>{{ tt("welcome.subtitle", "Conoce el flujo para convertir tus streams en clips listos para publicar.") }}</p>
    </header>

    <div class="welcome-videos">
      <article class="welcome-video welcome-video--featured">
        <div class="welcome-video-preview">
          <div class="welcome-video-preview__glow"></div>
          <i class="fa-brands fa-youtube welcome-video-preview__youtube" aria-hidden="true"></i>
          <span class="welcome-video-preview__badge">{{ tt("welcome.comingSoon", "PRÓXIMAMENTE") }}</span>
          <span class="welcome-video-preview__play" aria-hidden="true">
            <i class="ti-control-play"></i>
          </span>
        </div>
        <div class="welcome-video-copy">
          <span class="welcome-video-copy__label">{{ tt("welcome.featuredLabel", "VIDEO DE BIENVENIDA") }}</span>
          <h2>{{ tt("welcome.featuredTitle", "Bienvenido a Clipr") }}</h2>
          <p>{{ tt("welcome.featuredDescription", "Un recorrido rápido por todo lo que puedes hacer con Clipr.") }}</p>
        </div>
      </article>

      <div class="welcome-video-grid">
        <article
          v-for="video in videos"
          :key="video.titleKey"
          class="welcome-video"
        >
          <div class="welcome-video-preview">
            <i class="fa-brands fa-youtube welcome-video-preview__youtube" aria-hidden="true"></i>
            <span class="welcome-video-preview__badge">{{ tt("welcome.comingSoon", "PRÓXIMAMENTE") }}</span>
            <span class="welcome-video-preview__play" aria-hidden="true">
              <i class="ti-control-play"></i>
            </span>
          </div>
          <div class="welcome-video-copy">
            <h2>{{ tt(video.titleKey, video.title) }}</h2>
            <p>{{ tt(video.descriptionKey, video.description) }}</p>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      videos: [
        {
          titleKey: "welcome.videoCreateTitle",
          title: "Crea tu primer clip",
          descriptionKey: "welcome.videoCreateDescription",
          description: "Procesa un stream y encuentra los mejores momentos.",
        },
        {
          titleKey: "welcome.videoEditTitle",
          title: "Edita tus clips",
          descriptionKey: "welcome.videoEditDescription",
          description: "Ajusta el corte final antes de renderizar.",
        },
        {
          titleKey: "welcome.videoScheduleTitle",
          title: "Programa tus publicaciones",
          descriptionKey: "welcome.videoScheduleDescription",
          description: "Deja tus clips listos para publicar.",
        },
        {
          titleKey: "welcome.videoConnectionsTitle",
          title: "Conecta tus redes",
          descriptionKey: "welcome.videoConnectionsDescription",
          description: "Vincula tus plataformas para publicar desde Clipr.",
        },
      ],
    };
  },
  methods: {
    tt(key, fallback) {
      return typeof this.$t === "function" ? this.$t(key) : fallback;
    },
  },
};
</script>

<style scoped>
.welcome-page {
  max-width: 1280px;
  margin: 0 auto;
  padding: 18px 24px 48px;
}

.welcome-page-header {
  max-width: 680px;
  margin: 8px 0 30px;
}

.welcome-page-eyebrow,
.welcome-video-copy__label {
  color: #c4b5fd;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.welcome-page-header h1 {
  margin: 8px 0 10px;
  color: var(--clipr-text-primary, #f8fafc);
  font-size: clamp(32px, 5vw, 48px);
  font-weight: 800;
  letter-spacing: -0.045em;
}

.welcome-page-header p {
  margin: 0;
  color: var(--clipr-text-muted, #94a3b8);
  font-size: 16px;
  line-height: 1.55;
}

.welcome-videos {
  display: grid;
  gap: 24px;
}

.welcome-video {
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 16px;
  background: rgba(15, 23, 42, 0.56);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.2);
}

.welcome-video--featured {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(260px, 0.8fr);
}

.welcome-video-preview {
  position: relative;
  display: flex;
  aspect-ratio: 16 / 9;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background:
    radial-gradient(circle at 74% 22%, rgba(167, 139, 250, 0.38), transparent 30%),
    linear-gradient(135deg, #1e1b4b 0%, #312e81 52%, #111827 100%);
}

.welcome-video--featured .welcome-video-preview {
  min-height: 340px;
}

.welcome-video-preview__glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 25% 75%, rgba(236, 72, 153, 0.24), transparent 35%);
}

.welcome-video-preview__youtube {
  position: relative;
  color: #ff3d3d;
  font-size: 56px;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
}

.welcome-video-preview__badge {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 5px 7px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  background: rgba(15, 23, 42, 0.62);
  color: #e2e8f0;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.welcome-video-preview__play {
  position: absolute;
  right: 14px;
  bottom: 14px;
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 50%;
  background: rgba(15, 23, 42, 0.62);
  color: #fff;
  font-size: 12px;
}

.welcome-video-copy {
  padding: 18px;
}

.welcome-video--featured .welcome-video-copy {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px;
}

.welcome-video-copy h2 {
  margin: 7px 0 6px;
  color: var(--clipr-text-primary, #f8fafc);
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.welcome-video--featured .welcome-video-copy h2 {
  font-size: 28px;
}

.welcome-video-copy p {
  margin: 0;
  color: var(--clipr-text-muted, #94a3b8);
  font-size: 13px;
  line-height: 1.5;
}

.welcome-video-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

@media (max-width: 960px) {
  .welcome-video-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .welcome-video--featured .welcome-video-preview {
    min-height: 260px;
  }
}

@media (max-width: 700px) {
  .welcome-page {
    padding-right: 12px;
    padding-left: 12px;
  }

  .welcome-video--featured {
    grid-template-columns: 1fr;
  }

  .welcome-video--featured .welcome-video-preview {
    min-height: 0;
  }
}

@media (max-width: 480px) {
  .welcome-video-grid {
    grid-template-columns: 1fr;
  }

  .welcome-page-header {
    margin-bottom: 22px;
  }
}
</style>
